<template>
<div>
    <v-row class="justify-center">
        <v-col cols="12" sm="8" md="6">
            <v-card outlined>
                <div class="d-flex justify-center text-center white--text body-2 font-weight-medium info py-3">
                    <span>Photo</span> 
                </div>

                <v-card-text>
                    <!-- CROPPIE -->
                    <div v-if="modifying">
                        <div>
                            <vue-croppie 
                                ref="croppieRef" 
                                :enableResize="false"
                                :enableExif="true"
                                @result="result"
                                :boundary="{width:250, height:250}" 
                                :viewport="{width:200, height:200, type:'circle'}">
                            </vue-croppie>
                        </div>
                        <div class="text-center mb-3 caption">Adjust the photo.</div>
                        <div class="d-flex justify-center">
                            <v-btn text class="info--text" @click="modifying=false">Cancel</v-btn>
                            <v-btn depressed class="accent" @click="crop">Save</v-btn>
                        </div>
                    </div>

                    <!-- BOTÓN -->
                    <div class="my-3" v-if="!modifying">
                        <div v-if="!uploading && showImage"> 
                            <div class="d-flex justify-center">
                                <v-avatar size="120px">
                                    <img :src="user.photo.url" v-if="user.photo != null">
                                    <img src="@/assets/user-default.jpg" v-else>
                                </v-avatar> 
                            </div>
                            
                            <div class="text-center mt-2">
                                <v-btn large depressed class="accent mt-5" @click="openFile">
                                    <span v-if="user.photo == null">Upload photo</span>
                                    <span v-else>Edit photo</span>
                                </v-btn>
                            </div>
                            <input type="file" accept="image/*" ref="fileInput" style="display:none" @change="selectedFile">
                        </div>

                        <div class="d-flex justify-center mb-2" v-if="uploading"> 
                            <v-progress-circular :size="100" :width="15" :rotate="-90" :value="progress" color="secondary">
                                <span class="font-weight-bold">{{ Math.round(progress) }}</span>
                            </v-progress-circular>
                        </div>

                        <div class="d-flex justify-center">
                            <SendingLoader v-if="!showImage" />
                        </div>
                    </div>
                    
                </v-card-text>
            </v-card>

            <!-- <v-divider class="mt-8" v-if="$vuetify.breakpoint.mdAndUp"></v-divider> -->
        </v-col>
    </v-row>
</div>
</template>

<script>
import Validation from '@/services/validation'
import Sign from '@/firebase/sign'
import Personal from '@/firebase/personal'

export default {
    data: () => ({
        cropped: null,
        modifying: false,
        showImage: true
    }),
    computed: {
        progress() {
            return this.$store.getters.fileProgress;
        },
        uploading() {
            return this.$store.getters.fileUploading;
        },
        uploaded() {
            return this.$store.getters.fileUploaded;
        }
    },
    watch: {
        uploaded(val) {
            if (val === true) {
                this.showImage = false;
                Sign.reInitUser(this.user.uid);
                setTimeout(() => {
                    this.showImage = true;
                }, 500)
            }
        }
    },
    methods: {
        openFile() {
            this.$refs.fileInput.click();
        }, 
        selectedFile(event) {
            let files = event.target.files;

            var reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
                this.$refs.croppieRef.bind({
                    url: reader.result,
                });
                event.target.value = null;
            };
            reader.onerror = (error) => {
                console.log('Error: ', error);
            };

            this.modifying = true;
        },
        crop() {
            let options = {
                format: 'jpeg', 
                circle: true
            }

            let opt = {
				type: 'blob', //base64, html, blob, rawcanvas
				size: 'viewport', //original , viewport, {width, height}
				format: 'jpeg', //jpeg, png, webp
				quality: 1,
				circle: false
            }
            
            this.$refs.croppieRef.result(opt, (output) => {
                this.cropped = output;
                Personal.uploadFile(this.user.uid, Validation.guid(), this.cropped, this.user.photo);
                this.modifying = false;
            });
        },
        result(output) {
            this.cropped = output;
        },
        remove() {
            Personal.removeFile(this.user.uid, this.user.photo.name)
                        .then(response => {
                            if (response === true) {
                                this.$store.dispatch('setSnack', {kind:'success', text:'Se ha eliminado la foto.'});
                            } else {
                                this.$store.dispatch('setSnack', {kind:'error', text:'Ha ocurrido un error.'});
                            }
                        });
        }
    }
}
</script>